import React, { useState } from 'react';
import { compose } from '@/utils/story-composer';
import PointDown from '@/components/icons/point-down';
import PointUp from '@/components/icons/point-up';

function Accordion({ title, children, textColor }) {
	const [showContent, setShowContent] = useState(false);
	const toggleContent = () => setShowContent(!showContent);

	return (
		<div>
			<button type="button" onClick={toggleContent} className="flex justify-between items-center flex-row w-full">
				<span className="font-bold md:text-xl">{title}</span>
				{showContent ? (
					<PointUp className="md:hidden" color={textColor} />
				) : (
					<PointDown className="md:hidden" color={textColor} />
				)}
			</button>
			<div className={showContent ? 'block' : 'hidden md:block'}>{children}</div>
		</div>
	);
}

export default Accordion;

compose('accordion', Accordion);
